// 合同审核
import fetch,{ postFrom } from '../utils/fetch';

// 获取查询条件
export function getConditions() {
  return fetch({
      method: 'GET',
      url: 'contract/contractAuditCondition'
  })
}

// 获取合同审核列表
export function getList(params) {
  return fetch({
      method: 'GET',
      url: 'contract/contractAuditList',
      params
  })
}

// 个人合同签约人信息 
export function contractSignPeopleInfo(contractId) {
  return fetch({
      method: 'GET',
      url: 'contract/contractSignPeopleInfo',
      params: {
        contractId
      }
  })
}
// 查询个人合同信息 
export function personalContractInfo(contractId) {
  return fetch({
      method: 'GET',
      url: 'contract/personalContractInfo',
      params: {
        contractId
      }
  })
}
// 个人账单信息 
export function personalBillList(contractCode) {
  return fetch({
      method: 'GET',
      url: 'bill/findBillListByContractCode',
      params: {
        contractCode
      }
  })
}
// 个人交割信息 
export function personalDeliveryInfo(contractId) {
  return fetch({
      method: 'GET',
      url: 'sign/delivery/findDeliveryInfoDetail',
      params: {
        contractId
      }
  })
}

// 合同审核 
export function confirmAudit(data) {
  return postFrom('enterprisecontract/confirmAudit',data)
}

// 企业主合同签约人详情
export function getParentSignSubject(parentContractFid) {
  return fetch({
      method: 'GET',
      url: 'enterprisecontract/getSignSubject',
      params: {
        parentContractFid
      }
  })
}

// 企业主合同信息 
export function getParentContractInfo(parentContractFid) {
  return fetch({
      method: 'GET',
      url: 'enterprisecontract/getParentContractInfo',
      params: {
        parentContractFid
      }
  })
}

// 企业主合交割信息
export function getParentDeliveryState(parentContractFid) {
  return fetch({
      method: 'GET',
      url: 'enterprisecontract/getParentDeliveryState',
      params: {
        parentContractFid
      }
  })
}

// 子合同交割信息
export function getSubDeliveryState(contractFid) {
  return fetch({
      method: 'GET',
      url: 'enterprisecontract/getSubDeliveryState',
      params: {
        contractFid
      }
  })
}

// 企业主合同账单信息
export function getParentContractBillInfo(params) {
  return fetch({
      method: 'GET',
      url: 'enterprisecontract/getParentContractBillInfo',
      params
  })
}

// 企业主合同房间信息
export function getParentStockInfo(parentContractFid) {
  return fetch({
      method: 'GET',
      url: 'enterprisecontract/getStockInfo',
      params: {
        parentContractFid
      }
  })
}


// 查看补充协议列表 
export function getSupplyProtocolList(params) {
  return fetch({
    method:'GET',
    url:'/contract/getSupplyProtocolList',
    params
  })
}


// 删除补充协议列表 

// export function delSupplyProtocol(data) {
//   return fetch({
//     method:'POST',
//     url:'/contract/delSupplyProtocol',
//     data
//   })
// }

export function delSupplyProtocol(data) {
  return postFrom('/contract/delSupplyProtocol',data)
}